import script from "./StatusTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusTag.vue?vue&type=script&lang=ts&setup=true"

import "./StatusTag.vue?vue&type=style&index=0&id=15d4a07c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d4a07c"]])

export default __exports__